<template>
  <div id="contenedor-listado-temas">
    <v-skeleton-loader v-if="$apollo.loading" type="table-thead, table-tbody"></v-skeleton-loader>
    <v-simple-table v-else>
      <template>
        <thead>
          <tr>
            <th class="text-left" width="70">Clave</th>
            <th class="text-left" width="60%">Asunto</th>
            <th class="text-left">Responsables</th>
            <th width="50"></th>
            <th class="text-center" align="center" width="50">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="tema in getContratoTemas">
            <template>
              <tr :key="tema.id">
                <td class="font-weight-bold">
                  {{ tema.clave }}
                </td>
                <td class="font-weight-bold">{{ tema.descripcion }}</td>
                <td></td>
                <td>
                  <v-btn
                    text
                    small
                    rounded
                    @click="agregarSubTema(tema)"
                    class="text-capitalize"
                    color="primary"
                  >
                    <v-icon left>
                      mdi-plus
                    </v-icon>
                    Subtema
                  </v-btn>
                </td>
                <td class="text-center">
                  <v-menu v-model="tema.mostrarAcciones" :close-on-content-click="true" dense>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon> mdi-dots-vertical </v-icon>
                      </v-btn>
                    </template>
                    <v-list dense nav>
                      <v-list-item @click="agregarSubTema(tema)" link>
                        <v-list-item-icon class="mr-2">
                          <v-icon> mdi-plus </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Agregar Subtema </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mb-2 mt-1"></v-divider>
                      <v-list-item @click="editarTema(tema)" link>
                        <v-list-item-icon class="mr-2">
                          <v-icon> mdi-pencil </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Editar Tema </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="eliminarTema(tema)" link>
                        <v-list-item-icon class="mr-2">
                          <v-icon> mdi-delete </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Borrar Tema </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              <template v-for="subTema in tema.subTemas">
                <template>
                  <tr :key="subTema.id">
                    <td></td>
                    <td>
                      <div class="ml-1 font-weight-medium">
                        {{ subTema.descripcion }}
                      </div>
                    </td>
                    <td></td>
                    <td>
                      <v-btn
                        text
                        small
                        rounded
                        @click="agregarAsunto(subTema)"
                        class="text-capitalize"
                        color="blue darken-1"
                      >
                        <v-icon left>
                          mdi-plus
                        </v-icon>
                        Asunto
                      </v-btn>
                    </td>
                    <td class="text-center">
                      <v-menu
                        v-model="subTema.mostrarAcciones"
                        :close-on-content-click="true"
                        dense
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon> mdi-dots-vertical </v-icon>
                          </v-btn>
                        </template>
                        <v-list dense nav>
                          <v-list-item @click="agregarAsunto(subTema)" link>
                            <v-list-item-icon class="mr-2">
                              <v-icon> mdi-plus </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title> Agregar Asunto </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mb-2"></v-divider>
                          <v-list-item @click="editarSubTema(subTema)" link>
                            <v-list-item-icon class="mr-2">
                              <v-icon> mdi-pencil </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title> Editar Subtema </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click="eliminarSubTema(subTema)" link>
                            <v-list-item-icon class="mr-2">
                              <v-icon> mdi-delete </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title> Borrar Subtema </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template v-for="asunto in subTema.asuntos">
                  <template>
                    <tr :key="asunto.id">
                      <td></td>
                      <td>
                        <div class="ml-4">{{ asunto.numero }}.- {{ asunto.descripcion }}</div>
                      </td>
                      <td>{{ asunto.responsables }}</td>
                      <td></td>
                      <td class="text-center">
                        <v-menu
                          v-model="asunto.mostrarAcciones"
                          :close-on-content-click="true"
                          dense
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon> mdi-dots-vertical </v-icon>
                            </v-btn>
                          </template>
                          <v-list dense nav>
                            <v-list-item @click="editarAsunto(asunto)" link>
                              <v-list-item-icon class="mr-2">
                                <v-icon> mdi-pencil </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title> Editar Asunto </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="eliminarAsunto(asunto)" link>
                              <v-list-item-icon class="mr-2">
                                <v-icon> mdi-delete </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title> Borrar Asunto </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <!-- Ventana Editar Tema -->
    <v-dialog v-if="esteTema" v-model="mostrarEditarTema" width="500">
      <EditarTema :contratoTemaEditar="esteTema" v-on:cerrar="cerrarVentana" />
    </v-dialog>
    <!-- Ventana Eliminar Tema -->
    <v-dialog v-if="esteTema" v-model="mostrarEliminarTema" width="500">
      <EliminarTema :contratoTemaEliminar="esteTema" v-on:cerrar="cerrarVentana" />
    </v-dialog>
    <!-- Ventana Agregar Sub Tema -->
    <v-dialog v-if="esteTema" v-model="mostrarAgregarSubTema" width="500">
      <AgregarSubTema
        :idContrato="idContrato"
        :idTema="esteTema.id"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
    <!-- Ventana Editar Sub Tema -->
    <v-dialog v-if="esteSubTema" v-model="mostrarEditarSubTema" width="500">
      <EditarSubTema
        :contratoSubTemaEditar="esteSubTema"
        :idContrato="idContrato"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
    <!-- Ventana Eliminar Sub Tema -->
    <v-dialog v-if="esteSubTema" v-model="mostrarEliminarSubTema" width="500">
      <EliminarSubTema
        :contratoSubTemaEliminar="esteSubTema"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
    <!-- Ventana Agregar Asunto -->
    <v-dialog v-if="esteSubTema" v-model="mostrarAgregarAsunto" width="500">
      <AgregarAsunto
        :idTema="esteSubTema.idTema"
        :idSubTema="esteSubTema.id"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
    <!-- Ventana Editar Asunto -->
    <v-dialog v-if="esteAsunto" v-model="mostrarEditarAsunto" width="500">
      <EditarAsunto
        :contratoAsuntoEditar="esteAsunto"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
    <!-- Ventana Eliminar Asunto -->
    <v-dialog v-if="esteAsunto" v-model="mostrarEliminarAsunto" width="500">
      <EliminarAsunto
        :contratoAsuntoEliminar="esteAsunto"
        v-on:cerrar="cerrarVentana"
        v-on:actualizar="updateListado"
      />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_TEMAS from '@/graphql/querys/administracion/contratos/contrato/temas/contratoTemas.gql';
import AgregarSubTema from '@/components/administracion/contratos/contrato/subtemas/Agregar.vue';
import EditarTema from '@/components/administracion/contratos/contrato/temas/Editar.vue';
import EliminarTema from '@/components/administracion/contratos/contrato/temas/Eliminar.vue';
import EditarSubTema from '@/components/administracion/contratos/contrato/subtemas/Editar.vue';
import EliminarSubTema from '@/components/administracion/contratos/contrato/subtemas/Eliminar.vue';
import AgregarAsunto from '@/components/administracion/contratos/contrato/asuntos/Agregar.vue';
import EditarAsunto from '@/components/administracion/contratos/contrato/asuntos/Editar.vue';
import EliminarAsunto from '@/components/administracion/contratos/contrato/asuntos/Eliminar.vue';

export default {
  name: 'ListadoTemas',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  components: {
    AgregarSubTema,
    EditarTema,
    EliminarTema,
    EditarSubTema,
    EliminarSubTema,
    AgregarAsunto,
    EditarAsunto,
    EliminarAsunto,
  },
  apollo: {
    contratoTemas: {
      query: CONTRATO_TEMAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  data() {
    return {
      mostrarAgregarSubTema: false,
      mostrarEditarTema: false,
      mostrarEliminarTema: false,
      mostrarEditarSubTema: false,
      mostrarEliminarSubTema: false,
      mostrarAgregarAsunto: false,
      mostrarEditarAsunto: false,
      mostrarEliminarAsunto: false,
      esteAsunto: null,
      esteTema: null,
      esteSubTema: null,
    };
  },
  methods: {
    editarTema(tema) {
      this.esteTema = tema;
      this.mostrarEditarTema = true;
    },
    eliminarTema(tema) {
      this.esteTema = tema;
      this.mostrarEliminarTema = true;
    },
    agregarSubTema(tema) {
      this.esteTema = tema;
      this.mostrarAgregarSubTema = true;
    },
    editarSubTema(subTema) {
      this.esteSubTema = subTema;
      this.mostrarEditarSubTema = true;
    },
    eliminarSubTema(subTema) {
      this.esteSubTema = subTema;
      this.mostrarEliminarSubTema = true;
    },
    agregarAsunto(subTema) {
      this.mostrarAgregarAsunto = true;
      this.esteSubTema = subTema;
    },
    editarAsunto(asunto) {
      this.esteAsunto = asunto;
      this.mostrarEditarAsunto = true;
    },
    eliminarAsunto(asunto) {
      this.esteAsunto = asunto;
      this.mostrarEliminarAsunto = true;
    },
    cerrarVentana() {
      this.mostrarEditarTema = false;
      this.mostrarEliminarTema = false;
      this.mostrarAgregarSubTema = false;
      this.mostrarAgregarAsunto = false;
      this.mostrarEditarSubTema = false;
      this.mostrarEliminarSubTema = false;
      this.mostrarEditarAsunto = false;
      this.mostrarEliminarAsunto = false;
      this.esteAsunto = null;
      this.esteTema = null;
      this.esteSubTema = null;
    },
    updateListado() {
      this.$apollo.queries.contratoTemas.refetch();
    },
    ordenarPorValor(a, b) {
      if (Number(a) && Number(b)) {
        return Number(a) - Number(b);
      }

      return a.localeCompare(b);
    },
  },
  computed: {
    getContratoTemas() {
      if (!this.contratoTemas) return [];
      return this.contratoTemas.slice().map((tema) => ({
        ...tema,
        mostrarAcciones: false,
        subTemas: tema.subTemas.slice().map((subTema) => ({
          ...subTema,
          mostrarAcciones: false,
          asuntos: subTema.asuntos
            .slice()
            .map((accion) => ({
              ...accion,
              mostrarAcciones: false,
            }))
            .sort((a, b) => this.ordenarPorValor(a.numero, b.numero)),
        })).sort((a, b) => this.ordenarPorValor(a.descripcion, b.descripcion)),
      })).sort((a, b) => this.ordenarPorValor(a.clave, b.clave));
    },
  },
};
</script>

<style lang="scss" scoped></style>
